export enum SelectionCategories {
  PRIMARY_FILTER = 'primary_filter',
  REGION = 'region',
  CITY = 'city',
  JOB_CATEGORY = 'job_category',
  COMPANY = 'company',
  COMPANY_REPORT = 'company_report',
  COMPANY_NEW_DASHBOARD = 'company_new_dashboard',
  SNAPSHOT_DATE = 'snapshot_date',
  SENIORITY = 'seniority',
  EMPLOYMENT_RELATIONSHIP = 'employment_relationship',
  WORK_SCHEDULE = 'work_schedule',
  ROLE_K7 = 'role_k7',
  ROLE_K10 = 'role_k10',
  ROLE_K50 = 'role_k50',
  ROLE_K150 = 'role_k150',
  ROLE_K300 = 'role_k300',
  ROLE_K500 = 'role_k500',
  ROLE_K1000 = 'role_k1000',
  ROLE_K1250 = 'role_k1250',
  ROLE_K1500 = 'role_k1500',
  ROLE_K5000 = 'role_k5000',
  ROLE_K15000 = 'role_k15000',
  COUNTRY = 'country',
  SKILL = 'skill',
  SKILL_MAPPED = 'skill_mapped',
  SKILL_K25 = 'skill_k25',
  SKILL_K50 = 'skill_k50',
  SKILL_K75 = 'skill_k75',
  SKILL_K700 = 'skill_k700',
  SKILL_K2500 = 'skill_k2500',
  SKILL_K3000 = 'skill_k3000',
  SKILL_K15000 = 'skill_k15000',
  SKILL_K150 = 'skill_k150',
  SKILL_K1500 = 'skill_k1500',
  SKILL_K5000 = 'skill_k5000',
  SKILL_K35000 = 'skill_k35000',
  SKILL_0 = 'skill_0',
  SKILL_1 = 'skill_1',
  SKILL_2 = 'skill_2',
  SKILL_3 = 'skill_3',
  ACTIVITY_K150 = 'activity_k150',
  ACTIVITY_K1500 = 'activity_k1500',
  ACTIVITY_K5000 = 'activity_k5000',
  GENDER = 'gender',
  ETHNICITY = 'ethnicity',
  EDUCATION = 'education',
  HIGHEST_DEGREE = 'highest_degree',
  DEFAULT_COMPANIES = 'defaultCompanies',
  ROLES_TREE = 'roles_tree',
  REGIONS_TREE = 'regions_tree',
  START_TIME = 'start_time',
  END_TIME = 'end_time',
  INDUSTRY = 'industry',
  INDUSTRY_FULL = 'industry_full',
  RICS_K10 = 'rics_k10',
  RICS_K50 = 'rics_k50',
  RICS_K400 = 'rics_k400',
  KEYWORDS_CATEGORY = 'keyword_category',
  KEYWORD = 'keywords',
  RAW_TITLE = 'title_raw',
  MSA = 'msa',
  METRO_AREA = 'metro_area',
  FULL_MSA = 'full_msa',
  DATE_RANGE = 'date_range',
  DATE_RANGE_FULL = 'date_range_full',
  POSTING_METRIC = 'posting_metric',
  HEADCOUNT = 'headcount',
  HIRING_RATE = 'hiring',
  ATTRITION_RATE = 'attrition',
  GROWTH_RATE = 'growth',
  AVERAGE_TENURE = 'tenure',
  AVERAGE_SALARY = 'salary',
  COMPANY_NAME = 'company_name',
  CURRENT_COMPANY = 'current_company',
  STATE = 'state',
  COUNTY = 'county',
  TALENT_PAGE_ID = 'page',
  TALENT_PAGE_SIZE = 'num_results',
  COUNT = 'count',
  OTHER = 'other',
  COMPANY_RCID_MAPPINGS = 'company_rcid_mappings',
  METRIC_MODE = 'metric_mode',
  GEOGRAPHY = 'geography',
  DIVERSITY_INCLUSION = 'diversity_and_inclusion',
  EXPERIENCE = 'experience',
  ROLES = 'role',
  RSID = 'rsid',
  NAME = 'name',
  BASE_SALARY = 'base_salary',
  TOTAL_COMPENSATION = 'total_compensation',
  TOP_GEOGRAPHIES = 'top_geographies',
  TOP_COMPANIES = 'top_companies',
  TOP_ROLES = 'top_roles',
  TITLES = 'titles',
  GRADUATION_YEAR = 'graduation_year',
  CURRENCY = 'currency',
  CUSTOM_ROLE = 'custom_role',
}

export interface Item {
  id: string | number;
  parentId?: string;
  label?: string;
  longName?: string;
  shortName?: string;
  [key: string]: unknown;
}

export interface TreeItem<T = string> {
  item: Item | null;
  children: TreeItem<T>[];
  id: string;
  parentId?: string;
  selectionListId: SelectionListIdNames;
  isMulti?: boolean;
  isSelectableParent?: boolean;
}

type LocalSelectionCategoryValues =
  | 'primary_entities'
  | 'primary_filter'
  | 'snapshot_or_over_time'
  | 'posting_metric'
  | 'inflow_or_outflow'
  | 'n_items_sankey'
  | 'raw_metrics'
  | 'contingent_workers'
  | 'base_salary_or_total_comp'
  | 'provider'
  | 'prestige'
  | 'flight_risk'
  | 'remote_suitability'
  | 'metric_mode'
  | 'posting_granularity'
  | 'overall_rating';

type SubFilterNameValues =
  | 'sub_role'
  | 'sub_region'
  | 'sub_industry'
  | 'sub_skill'
  | 'sub_skill_overtime'
  | 'sub_seniority'
  | 'sub_gender'
  | 'sub_ethnicity'
  | 'sub_education'
  | 'sub_keyword';

type OtherFilterNameValues =
  | 'subfilter'
  | 'grouped'
  | 'last_month'
  | 'maxWeek'
  | 'inflow'
  | 'outflow'
  | 'dim1'
  | 'role_taxonomy'
  | 'skill_taxonomy'
  | 'activity_taxonomy';

export type SelectionListIdNames =
  | SelectionCategories
  | LocalSelectionCategoryValues
  | SubFilterNameValues
  | OtherFilterNameValues;

export type ValidValueTypes =
  | string
  | number
  | boolean
  | [number | Date, number | Date]
  | { startDate: string; endDate: string }
  | { id: string | number; label?: string }
  | unknown; // CustomRoleFilterValue | CustomRoleTaxonomySelection

export interface SelectionList<_T extends ValidValueTypes = ValidValueTypes> {
  id: SelectionListIdNames;
  label: SelectionListIdNames;
  value: Item[];
  parent?: SelectionListIdNames;
}

export type CustomRoleTaxonomyId =
  | 'custom_role_default'
  | `custom_role_rics_k10_${number}`
  | `custom_role_rics_k50_${number}`
  | `custom_role_taxonomy_${number}`;

export type CustomSkillTaxonomyId =
  | 'custom_skill_default'
  | `custom_skill_rics_k10_${number}`
  | `custom_skill_rics_k50_${number}`;

export type CustomActivityTaxonomyId =
  | 'custom_activity_default'
  | `custom_activity_rics_k10_${number}`
  | `custom_activity_rics_k50_${number}`;
